import { ClientType } from '../apollo'
import { types } from '../types'

import { updateOneAdvertisement } from '@dinosband/bv-main-schema/dist/client-gql'

export async function updateAdvertisement (client: ClientType, id: number, data: types.AdvertisementUpdateInput): Promise<types.Advertisement | undefined> {
  try {
    const result = await client.mutate({
      mutation: updateOneAdvertisement,
      variables: {
        where: { id },
        data,
      },
    })
    return result.data.updateOneAdvertisement
  } catch (e) {
  }
}
